import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { Link } from 'shared/types';
import { FormLinksBase } from './FormLinksBase';

export type InternalLinksFormValues = {
  expandInternalLinks: boolean;
  internalLinks: Link[];
};

export const FormInternalLinks = (): JSX.Element => {
  const isInternalTabEnabled = useReleaseFlag('internal_tab_on_incidents');

  if (isInternalTabEnabled) {
    return (
      <FormLinksBase
        labelKey="geoEvent.structuredInfo.links"
        linksField="internalLinks"
      />
    );
  }

  return (
    <FormLinksBase
      labelKey="createEditLocation.sections.internalLinks"
      linksField="internalLinks"
      expandField="expandInternalLinks"
    />
  );
};
